/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-09-06 14:15:44
 */
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Siema from 'siema';

@Component({
  selector: 'dt-form-carousel',
  templateUrl: './form-carousel.component.html',
  styleUrls: ['./form-carousel.component.scss'],
})
export class FormCarouselComponent implements OnInit, AfterViewInit {
  @Input() previewImage: string;
  @Input() previewIndex = 0;
  @Input() set previewVisible(isShow) {
    this.isShow = isShow;
    // setTimeout(() => {
    //   if (this.isShow) {
    //     // tslint:disable-next-line:no-unused-expression
    //     new Siema({
    //       selector: '.siema',
    //     });
    //   }
    // }, 100);
  }
  @Output() close = new EventEmitter<any>();
  isShow = false;
  constructor() {}

  ngOnInit() {}
  ngAfterViewInit(): void {}
  cancel() {
    this.close.emit();
  }
}
